export enum Roles {
    Codalt = 'codalt',
    Convert = 'convert',
    Customer = 'customer',
    Drawer = 'drawer',
    Management = 'management',
    Manager = 'manager',
    UserManagement = 'userManagement',
    Vakman = 'vakman',
    Workplanner = 'workplanner',
}
